module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Git3-56b10906ad266dfa69e8a16fa1bd5c9b.svg";